<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="400">
    <v-card id="send-email-modal">
      <form @submit.prevent="onSendEmail">
        <v-card-title>{{ $t("send_report_to_email") }}</v-card-title>
        <div class="dialog-text">
          {{ $t("send_report_to_email_text") + ` ${patientIntials}.` }}
          <div class="d-flex mt-8">
            <v-text-field
              v-model="email"
              :label="'email'"
              :rules="[rules.required, rules.email]"
              outlined
              dense
            />
          </div>
        </div>
        <v-card-actions class="d-flex justify-end">
          <v-btn class="mr-3" @click="onCloseDialog" text>{{
            $t("cancel")
          }}</v-btn>
          <v-btn type="submit" color="#415995" :loading="loading" text>{{
            $t("send")
          }}</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EmailModal",
  data() {
    return {
      email: null,
      rules: {
        required: value => !!value || this.$t("validate_required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("validate_email");
        }
      }
    };
  },
  props: {
    patientIntials: {
      type: String
    },
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  methods: {
    onCloseDialog() {
      this.$emit("close-dialog");
    },
    onSendEmail() {
      this.$emit("sendEmail", this.email);
    }
  }
};
</script>

<style lang="scss" scoped>
#send-email-modal {
  padding: 0;
  background: #f5f5f5;

  .dialog-text {
    padding: 2rem;
    background: white;
  }

  .v-card__title {
    word-break: break-word;
  }

  #error-message-wrapper {
    background-color: white;
    font-size: 1rem;
    color: red;
    margin-bottom: 2rem;
  }
}
</style>
